import React from 'react'

import { Form, Row, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const FiltroCosto = ({
  idServicio,
  setIdServicio,
  idSubServicio1,
  setIdSubServicio1,
  idSubServicio2,
  setIdSubServicio2,
  clickBuscar,
  ocultarTabla
}) => {
  const [servicios, setServicios] = React.useState([])
  const [subServicios1, setSubServicios1] = React.useState([])
  const [subServicios2, setSubServicios2] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSERVICIO).then(({ data }) => {
      setServicios(data)
    })
  }, [])

  React.useEffect(() => {
    ocultarTabla()

    if (idServicio) {
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO1, {
        _idServicio: idServicio
      }).then(({ data }) => {
        setSubServicios1(data)
      })
    } else {
      setSubServicios1([])
    }
  }, [idServicio, ocultarTabla])

  React.useEffect(() => {
    ocultarTabla()

    if (idSubServicio1) {
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO2, {
        _idSubServicio1: idSubServicio1
      }).then(({ data }) => {
        setSubServicios2(data)
      })
    } else {
      setSubServicios2([])
    }
  }, [idSubServicio1, ocultarTabla])

  return (
    <Row>
      <Col md={12}>
        <Form.Group>
          <Form.Label text='Servicio' md={4} alignRightAt='md' />
          <Col md={8}>
            <Form.Select
              id='select-servicio'
              name='select-servicio'
              value={idServicio}
              onChange={e => setIdServicio(e.target.value)}
            >
              <option value=''>Seleccionar</option>
              {servicios.map(x => (
                <option key={x._id} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label text='Sub Servicio 1' md={4} alignRightAt='md' />
          <Col md={8}>
            <Form.Select
              id='select-subservicio1'
              name='select-subservicio1'
              value={idSubServicio1}
              onChange={e => setIdSubServicio1(e.target.value)}
            >
              <option value=''>Seleccionar</option>
              {subServicios1.map(x => (
                <option key={x._id} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label text='Sub Servicio 2' md={4} alignRightAt='md' />
          <Col md={8}>
            <Form.Select
              id='select-subservicio2'
              name='select-subservicio2'
              value={idSubServicio2}
              onChange={e => {
                setIdSubServicio2(e.target.value)
                ocultarTabla()
              }}
            >
              <option value=''>Seleccionar</option>
              {subServicios2.map(x => (
                <option key={x._id} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Form.Group>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickBuscar}>Buscar</Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default React.memo(FiltroCosto)
